import axios from "../../axios";
import { ChangeSet, ChangeNames, ChangeTypes } from "../FirebaseClient/types";

export type InitialConfiguration = Required<ChangeSet<ChangeNames.BUILDING_ADDRESS>>;

export class ConfigurationClient {
    async create(conf: InitialConfiguration): Promise<string> {
        const response = await axios.post("configuration", conf, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.status !== 201) throw new Error("create configuration returned no 201");
        return response.headers!["location"]!.match(/.*\/(.+)$/)![1];
    }

    async update(params: { confId: string; conf: ChangeSet<keyof ChangeTypes> }): Promise<void> {
        const response = await axios.patch(`configurations/${params.confId}`, params.conf, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (response.status !== 200) throw new Error("update configuration didn't return 200");
    }

    /**
     * requests deletion of a draft configuration (when a confId is supplied) or a submitted configuration
     * including the associated order (when orderId is supplied)
     *
     * @param params {confId: "theId"} or {orderId: "theId"}
     */
    async remove(
        params: { confId: string; orderId?: undefined } | { confId?: undefined; orderId: string },
    ): Promise<void> {
        if (params.confId) {
            const response = await axios.delete(`configurations/${params.confId}`);
            if (response.status !== 202) throw new Error("delete configuration didn't return 202");
        } else {
            const response = await axios.delete(`orders/${params.orderId}`);
            if (response.status !== 202) throw new Error("delete order didn't return 202");
        }
    }

    async upgrade(confId: string): Promise<void> {
        try {
            await axios.post(`configurations/${confId}/upgrade`);
        } catch (e) {
            console.log("error in upgrade:" + e);
        }
    }

    async order(confId: string): Promise<string> {
        const response = await axios.post(`configurations/${confId}/order`);
        return response.headers!["location"]!.match(/.*\/(.+)$/)![1];
    }
}
export const defaultClient = new ConfigurationClient();
